import {createAction} from '@reduxjs/toolkit';
import {interpolateEndpoint} from './utils';
import {apiEndpoints} from 'modules/api/constants';
import slice from './slice';

export const apiResponsePrepareAction = (data, headers, context) => {
    return {
        payload: {
            data: Object.assign({}, data),
            headers: Object.assign({}, headers),
            context,
        },
    };
};

export const apiErrorPrepareAction = (error, context) => {
    let data = error.response?.data;
    if (!data) {
        data = error.message ? {error: error.message} : {};
    }
    return {
        payload: {
            error: data,
            context,
        },
    };
};

export const apiCallPrepareActionBuilder = (endpoint, method, request, success, error, baseUrl, failOn401) => {
    return (data, context) => {
        return {
            payload: {
                apiCall: {
                    endpoint: interpolateEndpoint(endpoint, context),
                    method,
                    data,
                    actions: {
                        request,
                        success,
                        error
                    },
                    context,
                    baseUrl,
                    failOn401: failOn401 || false
                }
            }
        }
    }
}

export const fireAndForget = createAction('api/fireAndForget');

export const refreshTokenAndRetry = createAction('api/refreshTokenAndRetry', (endpoint, method, data, actions, context) => {
    return {
        payload: {
            endpoint,
            method,
            data,
            actions,
            context
        }
    }
});

export const receiveAccessToken = createAction('api/receiveAccessToken', apiResponsePrepareAction);
export const accessTokenError = createAction('api/accessTokenError', apiErrorPrepareAction);
export const refreshAccessToken = createAction('api/getNewAccessToken', apiCallPrepareActionBuilder(
    apiEndpoints.REFRESH_ACCESS_TOKEN,
    'get',
    fireAndForget,
    receiveAccessToken,
    accessTokenError,
    null,
    true
));

export const retryApiCall = createAction('api/retryApiCall', (endpoint, method, data, actions, context) => {
    return {
        payload: {
            apiCall: {
                endpoint,
                method,
                data,
                actions,
                context,
                failOn401: true
            }
        }
    }
});

export const {apiCallInProgress} = slice.actions;